export enum PulmonaryQuestion {
  Question1 = '1. Akciğer grafisi sonucu NORMAL, çalışanın anamnezinde havayolu aşırı duyarlılığını düşündüren özgeçmiş veya semptomatik bir bulgu, fizik muayene patoloji bulgusu.',
  Question1ID = 'Soru1',
  Question2 = '2. Kişide belirgin torasik deformite, kronik solunum sistemi hastalığı düşündüren semptom veya muayene bulgusu ya da pulmoner patoloji.',
  Question2ID = 'Soru2',
}
